import React from "react";
import ConveniosYearPage from "./ConveniosYearPage";
import { convenios2015 } from "../../../../data/Convenios/dataConvenios";

const Convenios2015 = () => <ConveniosYearPage year={2015} data={convenios2015} />;

export default Convenios2015;